import { transparentize } from "./helperFn";

export const colors = {
  primary: "#579B3C",
  primary90: transparentize("#579B3C", 0.9),
  primary80: transparentize("#579B3C", 0.8),
  primaryDark: "#406205",
  primaryHover: "#5c9a4d",
  backgroundDark: "#0b1620",
  secondary: "hsl(30, 100%, 41%)",
  secondaryDark: "hsl(30, 100%, 26%)",
  secondaryHover: "hsl(30, 100%, 31%)",
  secondaryActive: "hsl(30, 100%, 26%)",
  headingDark: "#3B3F33",
  text: "#333333",
  textLight: "#505050",
  heading: "#3B3F33",
  textDarkMode: "#ffffff",
  textDarkMode85: transparentize("#ffffff", 0.85),
  textDarkMode80: transparentize("#ffffff", 0.8),
  btn: "#4B5A57",
  cta_btn: "#579B3C",
  cta_btn_text: "#fff",
  loyalty_primary: "#579b3c",
  standout_text: "#579b3c",
  added_to_cart_btn: "#009d00",
  category_header: "#e5e5e5",
  category_colored_header: "#E1EBD2",
  border: "#ebebeb",
  clickable_text: "#0066ff",
  featuredTag: "#ffaa00",
  hamburger: "#406205",
  menu_items: "#222",
  frozen: "#87ceeb",
  fresh: "#7CB342",
};

export const styles = {
  btn_border_radius: "5px",
  card_border_radius: "10px",
  bullet_point_icon: "💎  ",
  banner_padding_desktop: "80px",
  banner_padding_mobile: "48px",
};
